/**
 * /join/[token] — Public web invite landing route.
 *
 * Immediately redirects to /org/invite/[token] (the canonical acceptance screen).
 * This route exists so invite links sent as https://douevenlift.com/join/<token>
 * resolve correctly in the Expo web SPA.
 *
 * On native, the duel://org/invite/<token> deep link goes directly to the
 * acceptance screen via Expo Router's automatic scheme-based routing.
 */

import { useEffect } from 'react';
import { View, ActivityIndicator } from 'react-native';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { useTheme } from '@/contexts/ThemeContext';

export default function JoinRedirect() {
  const { token } = useLocalSearchParams<{ token: string }>();
  const router = useRouter();
  const { theme } = useTheme();

  useEffect(() => {
    if (token) {
      router.replace({
        pathname: '/org/invite/[token]',
        params: { token },
      } as any);
    } else {
      router.replace('/');
    }
  }, [token, router]);

  return (
    <View style={{ flex: 1, backgroundColor: theme.colors.background, alignItems: 'center', justifyContent: 'center' }}>
      <ActivityIndicator color={theme.colors.accent} />
    </View>
  );
}
